<div class='mb-xl space-x-md'>
  <button
    [class.selected]=''
    [ngClass]='{"text-primary": filter.value === selected}'
    class='btn btn-link font-semibold'
    *ngFor='let filter of filters'
    (click)='change.next(filter.value)'
  >
    {{ filter.label }}
  </button>
</div>
